<template>
  <div class="col-lg-8 col-md-8 col-12 detail-right">
    <div class="container">
      <div class="row search display-flex justify-content-between">
        <div class="form">
          <form class="form-training">
            <input
              v-model.lazy="keyword"
              v-debounce="300"
              type="text"
              placeholder="Tìm kiếm"
              required="required"
            />
            <button type="submit">
              <i class="fa fa-search secondary-color-blue"></i>
            </button>
          </form>
        </div>
        <div class="form-group select-status">
          <select class="form-control" id="status">
            <option>Tất cả thành viên</option>
            <option>Chưa tham gia</option>
            <option>Đã hoàn thành</option>
          </select>
          <i class="fa fa-angle-down"></i>
        </div>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col" class="title-table font-size-14 secondary-color-txt">Tên</th>
          <th scope="col" class="title-table font-size-14 secondary-color-txt">Người dùng</th>
          <th scope="col" class="title-table font-size-14 secondary-color-txt">Ngày đăng</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in getListClassDoccument.list" :key="index">
          <td data-label="Tên: " class="name-row-table font-family-Semibold font-size-14">
            <img src="@/assets/images/document1.png" alt />
            {{item.name}}
          </td>
          <td
            data-label="Người dùng :"
            class="name-row-table font-family-Semibold font-size-14"
          >{{item.author}}</td>
          <td
            data-label="Ngày đăng :"
            class="name-row-table font-family-Semibold font-size-14"
          > {{moment(item.createAt).format(formatDate)}}</td>
        </tr>
      </tbody>
    </table>
    <p class="col-12 text-center pagiination-training">
        <Pagination
            @eventPagination="getClassPagination"
            :totalPage="pagingData.totalPage"
            :page="pagingData.pageIndex"
        />
    </p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import BreadcrumClass from "../_components/breadcrumb/BreadcrumbClass";
import debounce from "@/directives/debounce";
import Pagination from "@/components/Pagination.vue";
import moment from "moment";
export default {
  name: "ViewCalendar",
  components: {
    Pagination,
     BreadcrumClass
  },
  directives: { debounce },
  data() {
    return {
      classSchoolSubjectId: this.$route.params.id,
      keyword: "",
      pagingData:{},
         formatDate: "DD/MM/YYYY",
    };
  },
  computed: {
    ...mapGetters({
      getListClassDoccument: STORE_KEY + "/getListClassDoccument",
      getParamDoccument: STORE_KEY + "/getParamDoccument"
    })
  },
  watch: {
    keyword: "changeKeyword",
    getParamDoccument: "getListDoccument",
    getListClassDoccument(newVal,oldVal){
        if(newVal){
            this.pagingData = newVal.paging;
        }
    }
  },
  mounted() {
    this.actionSetpramsDoccument({
      ...this.getParamDoccument,
      classSchoolSubjectId: parseInt(this.classSchoolSubjectId)
    });
    // this.actionGetListDocument();
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, [
    //   "actionGetListDocument",
      "actionSetpramsDoccument",
      "actionClassListDocument"
    ]),
    ...mapActions(`common`, ["setLoading"]),
    moment,
    changeKeyword() {
      this.actionSetpramsDoccument({
        ...this.getParamDoccument,
        keyword: this.keyword
      });
    },
    getListDoccument() {
      this.actionClassListDocument(this.getParamDoccument);
    },
    getClassPagination(value) {
      this.setLoading(true);
      this.actionSetpramsDoccument({
        ...this.getParamDoccument,
        pageIndex: value
      }).finally(() => {
        this.setLoading(false);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table {
  tr:first-child {
    border-top: 2px solid #fff;
  }
  tbody {
    tr {
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  img {
    margin-right: 10px;
  }
}
.search {
  .form {
    height: 30px;
    width: 377px;
    .form-training {
      position: relative;
      button {
        position: absolute;
        top: 4px;
        z-index: 1;
        background-color: transparent;
        border: 0;
        color: #124abe;
        outline: 0;
        right: 13px;
        font-size: 14px;
      }
      input {
        border-radius: 20px;
        height: 30px;
        padding: 0 35px 0 12px;
        top: 0;
        left: 0;
        border: 0;
        color: #40505e;
        outline: 0;
        background-color: #f3f6fb;
        font-size: 15px;
        width: 100%;
        position: static;
      }
    }
  }
  .select-status {
    position: relative;
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      padding: 2px 30px 2px 10px;
      border: none;
      background: none;
      border-radius: 20px;
      height: 30px;
      font-size: 14px;
      color: #879aa9;
    }
    i {
      position: absolute;
      top: 7px;
      right: 8px;
      color: #879aa9;
    }
  }
}
.dropdown-account {
  margin-left: 10px;
}
.dropdown button {
  width: 30px;
  background: #f3f6fb;
  color: #879aa9;
  font-size: 14px;
  text-align: center;
  border: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 30px;
  height: 30px;
  outline: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #124abe;
  text-decoration: none;
  background: #f3f6fb;
}
.dropdown button:focus {
  background: #f3f6fb !important;
  color: #124abe;
}
.dropdown-toggle::after {
  display: none;
}
.dropdown-menu {
  padding: 0rem 0 0.5rem;
  margin: 0.125rem 0 0;
  box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
  transform: translate3d(-95px, 30px, 0px) !important;
}
@media (max-width: 425px) {
  .dropdown-menu {
    padding: 0rem 0 0.5rem;
    margin: 0.125rem 0 0;
    box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
    transform: translate3d(167px, 30px, 0px) !important;
  }
}
</style>